import { z } from 'zod';
import { auditLogSchema } from '../schemas/audit.js';
import { listQueryBase, paginatedResponse } from './_shared.js';
/**
 * Audit row joined with the actor's user info. `actor` is null when the
 * row's `actor_id` does not resolve to a row in `users` (e.g. the
 * system-actor sentinel `00000000-...0` intentionally absent).
 */
export const adminAuditRowSchema = auditLogSchema.extend({
    actor: z
        .object({
        id: z.string().uuid(),
        displayName: z.string().nullable(),
        email: z.string().email(),
    })
        .nullable(),
});
/**
 * `GET /api/audit` query — pagination + AND'd filters + optional sort.
 * Composes `listQueryBase` (pagination + sort) but re-applies `pageSize`
 * last so the 200-row ceiling wins over the base's 100-row cap.
 *
 * `pageSize` ceiling is 200 here (vs. 100 for most endpoints) because the
 * audit tab routinely scrolls older windows during incident review. The
 * `.extend` is Zod last-key-wins, so the override is the final key.
 *
 * `sort` is a signed comma-joined field list (e.g. `-createdAt,action`).
 * Allowed fields: `createdAt`, `action`, `actorId`, `resourceType`.
 * Invalid fields → 400 VALIDATION_ERROR from the route layer.
 */
export const listAuditQuerySchema = listQueryBase.extend({
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    action: z.string().trim().min(1).optional(),
    actorId: z.string().uuid().optional(),
    resourceType: z.string().trim().min(1).optional(),
    resourceId: z.string().trim().min(1).optional(),
});
/**
 * Export query: same filters + sort as the list query but without pagination.
 * Used by `GET /api/audit/export` to stream all matching rows as CSV.
 * Row-level scoping applies identically to the list route — non-admins only
 * export their own actor_id rows.
 */
export const exportAuditQuerySchema = listAuditQuerySchema.omit({
    page: true,
    pageSize: true,
});
export const listAuditResponseSchema = paginatedResponse(adminAuditRowSchema);
//# sourceMappingURL=audit.js.map